import React from 'react';
import { PartnerProfile } from '@css-xp/ppc-types';
import { ProfileAvatar } from '@css-xp/ppc-profile-avatar';
import './user-info.scss';

export const UserInfo = ({ user }: { user: PartnerProfile }) => {
  return (
    <div className="ppc-user-info">
      <div className="profile-avatar">
        <ProfileAvatar picture={user?.picture} testIdPrefix="home-avatar" size="large" borderColor="transparent" />
      </div>
      <div className="ml-4">
        <div className="profile-name">Welcome {user.displayName}</div>
        <div className="mt-4 ml-4">{user.jobTitle}</div>
      </div>
    </div>
  );
};
